export default "__VITE_ASSET__CxeLJBGt__"